import type {BaseComponentConfig} from "@gamzix/slot_core";

class PreloaderComponent extends Game.src.component.BaseComponent {

    constructor(config: BaseComponentConfig) {
        super(config);

        const params = new URLSearchParams(new URL(window.location.href).search);
        const provider = params.get('provider');

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isNotGamzix: () => provider ? params.get('provider') === "gamzix" : true
        };
    }

    createView() {
        if (this.options.view) {
            const view = game.builder.create(this.options.view);

            this.view = <any>view;
            game.render.addChild(view);

            this.updateStatusCheckersView(this.status_checkers, this.text_checkers);
        }
    }

    show() {
        this.createView();
        this.subscribeOnLoad();
    }

    hide() {
        let preloader = game.tree.findByName('preloader');
        preloader.options.visible = false;

        this.onChangeOrientation();
    }

    subscribeOnLoad() {
        let maskPreloader = game.tree.findByName('mask_preloader');
        let progressBarImage = game.tree.findByName('progress_bar_image');

        game.on(AssetsLoaderService.events.PROGRESS_LOADING, (data) => {
            maskPreloader.options.width = ((progressBarImage.width / 100) * data)*2;
            this.onChangeOrientation();
        })
    }


    getFSMHandlers() {
        return {
            LOADING: {
                loadComponentsResources: {
                    on: () => {
                        this.show();
                        preloader.hide();
                    }
                }
            },
            IDLE: {
                enter: {
                    on: () => {
                        this.hide();
                    }
                }
            },
        }
    }

    onGameReady() {}
}

// @ts-ignore
Game.src.component.PreloaderComponent = PreloaderComponent;
